module.exports = __webpack_public_path__ + "static/tuv-logo-527cd882fbcf7a56955c200b8437feb9.jpg";